import WebRequest from "./WebRequest";
import Configuration from "../foundation/Configuration";

class DatastoreMessaging extends WebRequest {
    protected static get includeAuth(): boolean {
        return true;
    }
    
    static override get basePath(): string {
        return `${Configuration.messagingPath}/`;
    }
}

export default DatastoreMessaging;
